// "First Middle Last": trimmed, empty/null parts skipped, single spaces.
export const fullTeacherName = (first, middle, last) =>
  [first, middle, last]
    .map((s) => (s || '').trim())
    .filter(Boolean)
    .join(' ');

// Full name from a teacher row; real surname (CMS-only last_name_full_value) wins over the initial.
export const teacherFullNameOf = (teacher) =>
  teacher
    ? fullTeacherName(
        teacher.first_name,
        teacher.middle_name,
        teacher.last_name_full_value || teacher.last_name
      )
    : '';
